import { GlobalResponseObject } from '../../../common';
import { LoginModel } from './login.model';

export class LoginResponse extends GlobalResponseObject {
    data?: LoginModel;
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: LoginModel) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}